<template>
  <div class="footer">
    <div class="footer_bg">
      <div class="footer_t">
        <div class="footer_t_m">
          <img src="../../assets/image/zxl_logo.png" />
        </div>
      </div>
      <div class="footer_b">
        <div class="footer_b_l">
          <div>广州共生柠萌信息技术有限公司</div>
          <div>联系电话：18030098225</div>
          <div>地址：广州市白云区尖彭路395号1219室</div>
          <div>
            <a
              target="_blank"
              class="blank"
              href="https://beian.miit.gov.cn/#/Integrated/index"
              >粤ICP备2021066618号-1</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getBottomNav } from "@/api/index.js";
export default {
  data() {
    return {
      navList: [
        { title: "商务合作", routerPath: "/cooperation" },
        { title: "关于运东", routerPath: "/aboutUs" },
      ],
      footerData: {},
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
$width: 1200px;
.footer {
  width: 100vw;
  height: auto;
  .footer_bg {
    width: 100%;
    height: auto;
    background: #202020;
  }
  &_t {
    width: 100%;
    height: 70px;
    border-bottom: 1px solid rgba($color: #f8f8f8, $alpha: 0.1);

    &_m {
      width: $width;
      height: 70px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      img {
        width: 140px;
        height: 41px;
      }
    }
  }
  &_b {
    width: $width;
    height: auto;
    margin: 0 auto;
    padding: 40px 0px;
    box-sizing: border-box;
    color: #f4f8ff;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    &_l {
      .contact_time {
        display: flex;
        column-gap: 50px;
      }
      div {
        margin-bottom: 19px;
      }
    }
  }
}
.blank {
  color: #ffffff;
}
.blank:hover {
  color: #2870ff;
}
</style>
